import { Injectable } from "@angular/core";
import { DataFile } from "@bioconnect-ui/curation-service";
import { FileType } from "@bioconnect-ui/structured-data-service";
import { StoredFile } from "@bioconnect-ui/file-service";


export interface DataPackageServiceConfig {
  restServer: string;
}

/**
 * Enumeration for the package status values
 */
 export enum PackageStatus {
  QUEUED = 'Queued',
  INPROCESS = 'In Progress',
  DONE = 'Done'
}

export interface DataPackage {
  id: number;
  name: string;
  user_name: string;
  description: string;
  size: number;
  files: DataPackageFile[];
  status: PackageStatus;
  created: Date;
  updated: Date;
}

export interface DataPackageFile {
    id: number;
    storedfile_id: string;
    data_package: DataPackage;
}


export interface PackageAssay {
    id: number;
    identifier: string;
    description: string;
    investigation?: number;
    investigation_identifier?: string;
    study?: number;
    study_identifier?: string;
    measurement_type?: string;
}

export interface PackageFile extends DataFile {
    filetype: number;
    file_id: number;
    type: string;
    file_type: string;
    size: number;
    investigation_identifier: string;
    study_identifier: string;
    assay_identifier: string;
    assay: PackageAssay;
    expanded: boolean;
    include_in_metadata: boolean;
    include_in_download: boolean;
    file_type_object?: FileType;
  }

/**
 * Maps a StoredFile to a DataPackage
 */
 export interface DataPackageFile {
    data_package: DataPackage;
    file: StoredFile;
  }
  
/**
 * A PagedResponse is a generic interface to handle
 * native Django API responses which include
 * count and paging data
 */
 export interface PagedResponse {
  count: number;
  next: string;
  previous: string;
  results: unknown[]
}

/**
 * User Profile represents the Auth0 logged in user
 */
 export interface UserProfile {
  email: string;
  name: string;
}

@Injectable({
    providedIn: 'root',
})

export class CoreDataPackageTypes {

}